import React, { PropsWithChildren } from 'react';
import { Link } from 'react-router';
import { useHasAccessServices } from 'components/hooks/services/useBoardServices';
import { useServiceDescriptionLink } from 'components/hooks/services/useServiceDescriptionLink';
import { useLoggerTracking } from 'components/hooks/logger/useLoggerTracking';
import { TrackedFeature, TrackedPage, TRACKING_PARAM_KEYS } from 'services/Logger';

type ServiceLinkProps = {
    serviceKey: Nullable<string>;
    url: Nullable<string>;
    className?: string;
    trackedPage?: TrackedPage;
};

export const ServiceLink: React.FunctionComponent<PropsWithChildren<ServiceLinkProps>> = ({
    serviceKey,
    url,
    className,
    children,
    trackedPage = TrackedPage.ServiceDetail,
}) => {
    const descriptionUrl = useServiceDescriptionLink(serviceKey);
    const { hasAccessTo } = useHasAccessServices();
    const track = useLoggerTracking();

    if (!serviceKey) {
        return <div className={className}>
            {children}
        </div>;
    }

    const canAccess = hasAccessTo(serviceKey);
    if (canAccess && url) {
        return <a
            href={url}
            onClick={() => track(trackedPage, TrackedFeature.OpenService, { [TRACKING_PARAM_KEYS.serviceKey]: serviceKey })}
            target="_blank"
            rel="noopener noreferrer"
            className={className}
        >
            {children}
        </a>;
    }

    return <Link to={descriptionUrl}
        onClick={() => track(trackedPage, TrackedFeature.OpenServiceDetail, { [TRACKING_PARAM_KEYS.serviceKey]: serviceKey })}
        className={className}
    >
        {children}
    </Link>;
};
